module.exports = __webpack_public_path__ + "img/Bank.8ace50ba.svg";